import schemeHeaderEn from "./locales/en.json";

export const SCHEME_HEADER_NS = "schemeHeader" as const;

export const SchemeHeaderI18n = {
  en: {
    [SCHEME_HEADER_NS]: {
      ...schemeHeaderEn,
    },
  },
};
